"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isLoggedIn = async ({ functionId, callbacks, executeProcesses, processor, }) => {
    const { currentUser } = processor.root.firebase.auth();
    if (currentUser) {
        executeProcesses(functionId, callbacks.isLoggedIn, currentUser);
        return;
    }
    executeProcesses(functionId, callbacks.isNotLoggedIn, undefined);
};
exports.default = isLoggedIn;
